import React from "react";

export type OtpInputProps = {
  value: string;
  onChange: (value: string) => void;
  length?: number;
  disabled?: boolean;
  error?: boolean;
  inputStyle?: React.CSSProperties;
};

const OtpInput: React.FC<OtpInputProps> = ({
  value,
  onChange,
  length = 6,
  disabled,
  error,
  inputStyle,
}) => {
  const inputRefs = React.useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (index: number, char: string) => {
    const next = (
      value.slice(0, index) +
      char.replace(/\D/g, "").slice(-1) +
      value.slice(index + 1)
    ).slice(0, length);
    onChange(next);
    if (char && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");
    const pasteValue = pasteData.slice(0, length);
    onChange(pasteValue);
    // フォーカスを最後の入力された文字の次の入力欄に移動
    const nextIndex = Math.min(pasteValue.length, length - 1);
    inputRefs.current[nextIndex]?.focus();
  };

  return (
    <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          ref={(el) => (inputRefs.current[i] = el)}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={1}
          value={value[i] || ""}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          disabled={disabled}
          style={{
            width: 36,
            height: 40,
            textAlign: "center",
            fontSize: 18,
            borderRadius: 6,
            border: `1px solid ${error ? "#d32f2f" : "#c7c7c7"}`,
            ...inputStyle,
          }}
        />
      ))}
    </div>
  );
};

export default OtpInput;
